import { render, staticRenderFns } from "./dialog-consent-register-mohpromt.vue?vue&type=template&id=2cf44615&"
import script from "./dialog-consent-register-mohpromt.vue?vue&type=script&lang=js&"
export * from "./dialog-consent-register-mohpromt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports